import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Asset, GetProductPageQuery } from '../../../common/generated-types';
import { ProductCustomizationOption } from '../../../common/interfaces';


type Variant = NonNullable<GetProductPageQuery['productPage']['productInfo']>['variants'][number];

@Component({
    selector: 'vsf-desktop-shop-now-banner',
    templateUrl: './desktop-shop-now-banner.component.html',
    styleUrls: ['./desktop-shop-now-banner.component.scss'],
})
export class DesktopShopNowBannerComponent implements OnInit, OnChanges {
    @Input() product: GetProductPageQuery['productPage']['productInfo'];
    @Input() selectedVariant: Variant;
    @Input() selectedPrintTemplate: ProductCustomizationOption | null = null;
    @Input() inStock = true;
    @Input() isMobile: boolean = false;
    @Input() allCustomizationOptions: ProductCustomizationOption[] = [];
    @Input() messageValues: { [optionId: string]: string } = {};
    @Input() selectedPaidOptionValues: { [optionId: string]: string } = {};
    inFlight = false;
    selectedVariantMSRP: number | null = null;
    discountPercentage: number | null = null;
    optionsWithGroupNames: { groupName: string, optionName: string }[] = [];
    featuredAsset: Asset | null = null;

    constructor() { }

    ngOnInit() {
        this.updateVariant();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedVariant || changes.product) {
            this.featuredAsset = this.selectedVariant?.featuredAsset as Asset || this.product?.featuredAsset || null;
            this.processOptions();
        }
        if (changes['selectedVariant']) {
          this.updateVariant();
        }
    }

    private processOptions() {
        if (this.selectedVariant && this.product) {
          const optionGroups = this.product.optionGroups;
          this.optionsWithGroupNames = this.selectedVariant.options.map(option => {
            const group = optionGroups.find(group => group.id === option.groupId);
            return {
              groupName: group ? group.name : 'Unknown',
              optionName: option.name,
            };
          });
        } else {
          this.optionsWithGroupNames = [];
        }
    }

    updateVariant() {
        this.featuredAsset = this.selectedVariant?.featuredAsset as Asset || this.product?.featuredAsset || null;
        if (this.selectedVariant && this.selectedVariant.customFields?.MSRP && this.selectedVariant.customFields.MSRP !== 0) {
            this.selectedVariantMSRP = this.selectedVariant.customFields.MSRP;
            const price = this.selectedVariant.price;
            const msrp = this.selectedVariantMSRP;
            if (msrp && msrp > price) {
                this.discountPercentage = ((msrp - price) / msrp) * 100;
            } else {
                this.discountPercentage = null;
            }
        } else {
            this.selectedVariantMSRP = null;
            this.discountPercentage = null;
        }
    }
}
